module.exports = __webpack_public_path__ + "media/images/city/075-statue-of-liberty-ebd7ea8175e6a67acfe7931b4f00dfe4.svg";